/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import R from 'ramda'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List, ListItem, ListItemText, ListItemIcon, Tooltip, Collapse, IconButton, Divider } from '@material-ui/core'
import { Mail, ExpandLess, ExpandMore } from '@material-ui/icons'

import * as constants from 'constants/Prestation'
import * as loginConstants from 'constants/Login'

class ContributorsPanel extends React.Component {

  constructor (props) {
    super(props)

    const defaultOpen = this.props.user.role !== loginConstants.INTERPRETER_ROLE

    this.state = {
      open: true,
      openInterpreterInformation: defaultOpen,
      openApplicantInformation: false,
      openPayingCustomerInformation: false,
      openConsumerInformation: false
    }
  }

  handleChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  consumer () {
    const firstName = R.path(['consumers', 0, 'identities', 0, 'first_name'], this.props.prestation) || ''
    const lastName = R.path(['consumers', 0, 'identities', 0, 'last_name'], this.props.prestation) || ''
    const entity = R.path(['consumers', 0, 'entities', 0, 'name'], this.props.prestation) || ''

    let text = firstName ? firstName + ' ' + lastName : ''
    text += entity ? ' - ' + entity : ''

    return text || this.props.intl.formatMessage(constants.messages.DETAIL_NO_CONSUMER_MESSAGE)
  }

  beneficiary () {
    const firstName = R.path(['beneficiary_numbers', 0, 'beneficiary', 'identities', 0, 'first_name'], this.props.prestation)
    const lastName = R.path(['beneficiary_numbers', 0, 'beneficiary', 'identities', 0, 'last_name'], this.props.prestation)
    const birthDate = R.path(['beneficiary_numbers', 0, 'beneficiary', 'identities', 0, 'birth_date'], this.props.prestation)
    const beneficiaryNumberType = R.path(['beneficiary_numbers', 0, 'number_type', 'value'], this.props.prestation)
    const beneficiaryNumber = R.path(['beneficiary_numbers', 0, 'number'], this.props.prestation)

    let text = firstName ? firstName + ' ' + lastName : ''
    text += birthDate ? ', ' + moment(birthDate, 'YYYY-MM-DD').format('DD.MM.YYYY') : '' 
    if (text !== '' && (beneficiaryNumberType || beneficiaryNumber)) {
      text += ', '
    }    
    text += beneficiaryNumberType ? beneficiaryNumberType + ' ' : ''
    text += beneficiaryNumber || ''

    return text || this.props.intl.formatMessage(constants.messages.DETAIL_NO_BENEFICIARY_MESSAGE)
  }

  render() {
    const isStaff = this.props.user.is_staff

    const applicantPhoneNumbers = R.path(['applicant', 'entities', 0, 'phone_numbers'], this.props.prestation) ||
      R.path(['applicant', 'identities', 0, 'phone_numbers'], this.props.prestation)

    const applicantAddress = R.path(['applicant', 'entities', 0, 'address', 'address'], this.props.prestation) ||
      R.path(['applicant', 'identities', 0, 'address', 'address'], this.props.prestation)

    const payingCustomerPhoneNumbers = R.path(['paying_customer', 'entities', 0, 'phone_numbers'], this.props.prestation) ||
      R.path(['paying_customer', 'identities', 0, 'phone_numbers'], this.props.prestation)

    const payingCustomerAddress = R.path(['paying_customer', 'entities', 0, 'address', 'address'], this.props.prestation) ||
      R.path(['paying_customer', 'identities', 0, 'address', 'address'], this.props.prestation)

    return (
      <List>
        <ListItem 
          button 
          onClick={() => this.handleChange('open', !!!this.state.open)}
          style={{paddingLeft: 16, paddingRight: 16}}
        >
          <ListItemText primary={this.props.intl.formatMessage(constants.messages.DETAIL_CONTRIBUTORS_LABEL)}/>
          {
            this.state.open 
              ? <ExpandLess /> 
              : <ExpandMore />
          }
        </ListItem>

        <Collapse 
          in={this.state.open} 
          unmountOnExit
        >
          <List 
            component="div" 
            disablePadding
            style={this.props.style}
          >
            {
              R.path(['interpreter', 'uid'], this.props.prestation)
                ? <React.Fragment>
                  <ListItem
                    style={this.props.itemStyle}
                  > 
                    <ListItemText
                      primary={this.props.interpreter || this.props.intl.formatMessage(constants.messages.DETAIL_NO_INTERPRETER_MESSAGE)}
                      secondary={this.props.intl.formatMessage(constants.messages.DETAIL_INTERPRETER_LABEL)}
                    />

                    <ListItemIcon>
                      <Tooltip title={this.props.intl.formatMessage(constants.messages.SEND_INTERPRETER_EMAIL_LABEL)}>
                        <IconButton
                          onClick={() => {
                            const email = R.path(['interpreter', 'identities', 0, 'emails'], this.props.prestation)
                            if (email) window.location.href = `mailto:${email}`
                          }
                        }
                        >
                          <Mail />
                        </IconButton>
                      </Tooltip>
                    </ListItemIcon>

                    {
                      this.state.openInterpreterInformation 
                        ? <IconButton onClick={() => this.handleChange('openInterpreterInformation', !!!this.state.openInterpreterInformation)}>
                          <ExpandLess />
                        </IconButton>
                        : <IconButton onClick={() => this.handleChange('openInterpreterInformation', !!!this.state.openInterpreterInformation)}>
                          <ExpandMore />
                        </IconButton>
                    }
                  </ListItem>

                  <Collapse 
                    in={this.state.openInterpreterInformation} 
                    unmountOnExit
                  >
                    <List 
                      component="div" 
                      disablePadding
                      style={this.props.style}
                    >
                      <ListItem
                        style={this.props.itemStyle}
                      >
                        <ListItemText
                          primary={R.path(['interpreter', 'identities', 0, 'emails'], this.props.prestation)}
                          secondary={this.props.intl.formatMessage(constants.messages.EMAIL)}
                        />

                        <ListItemText
                          primary={R.path(['interpreter', 'identities', 0, 'phone_numbers'], this.props.prestation)}
                          secondary={this.props.intl.formatMessage(constants.messages.PHONE)}
                        />
                      </ListItem>
                    </List>
                    <Divider />
                  </Collapse>
                </React.Fragment>
                : undefined
            }

            <ListItem
              style={this.props.itemStyle}
            >
              <ListItemText
                primary={this.consumer()}
                secondary={this.props.intl.formatMessage(constants.messages.DETAIL_CONSUMER_LABEL)}
              />
              {
                isStaff &&
                R.path(['consumers', 0], this.props.prestation)
                  ? <React.Fragment>
                    {
                      this.state.openConsumerInformation
                        ? <IconButton onClick={() => this.handleChange('openConsumerInformation', !!!this.state.openConsumerInformation)}>
                          <ExpandLess />
                        </IconButton>
                        : <IconButton onClick={() => this.handleChange('openConsumerInformation', !!!this.state.openConsumerInformation)}>
                          <ExpandMore />
                        </IconButton>
                    }
                  </React.Fragment>
                  : undefined
              }
            </ListItem>

            <Collapse
              in={
                this.state.openConsumerInformation &&
                isStaff &&
                R.path(['consumers', 0], this.props.prestation)
              }
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                style={this.props.style}
              >
                <ListItem
                  style={this.props.itemStyle}
                >
                  <ListItemText
                    primary={R.path(['consumers', 0, 'identities', 0, 'emails'], this.props.prestation)}
                    secondary={this.props.intl.formatMessage(constants.messages.EMAIL)}
                  />

                  <ListItemText
                    primary={R.path(['consumers', 0, 'identities', 0, 'phone_numbers'], this.props.prestation)}
                    secondary={this.props.intl.formatMessage(constants.messages.PHONE)}
                  />
                </ListItem>
              </List>
              <Divider />
            </Collapse>

            <ListItem
              style={this.props.itemStyle}
            >
              <ListItemText
                primary={this.props.applicant}
                secondary={this.props.intl.formatMessage(constants.messages.DETAIL_APPLICANT_LABEL)}
              />
              {
                isStaff &&
                R.path(['applicant'], this.props.prestation)
                  ? <React.Fragment>
                    {
                      this.state.openApplicantInformation
                        ? <IconButton onClick={() => this.handleChange('openApplicantInformation', !!!this.state.openApplicantInformation)}>
                          <ExpandLess />
                        </IconButton>
                        : <IconButton onClick={() => this.handleChange('openApplicantInformation', !!!this.state.openApplicantInformation)}>
                          <ExpandMore />
                        </IconButton>
                    }
                  </React.Fragment>
                  : undefined
              }            
            </ListItem>

            <Collapse 
              in={
                this.state.openApplicantInformation &&
                isStaff &&
                R.path(['applicant'], this.props.prestation)
              }
              unmountOnExit
            >
              <List 
                component="div" 
                disablePadding
                style={this.props.style}
              >
                {
                  applicantPhoneNumbers
                    ? <ListItem
                      style={this.props.itemStyle}
                    >
                      <ListItemText
                        primary={applicantPhoneNumbers}
                        secondary={this.props.intl.formatMessage(constants.messages.PHONE)}
                      />

                    </ListItem>
                    : undefined
                }

                {
                  applicantAddress
                    ? <ListItem
                      style={this.props.itemStyle}
                    >
                      <ListItemText
                        primary={applicantAddress}
                        secondary={this.props.intl.formatMessage(constants.messages.ADDRESS)}
                      />

                    </ListItem>
                    : undefined
                }
              </List>
              <Divider />
            </Collapse>

            <ListItem
              style={this.props.itemStyle}
            >
              <ListItemText
                primary={
                  R.path(['paying_customer', 'entities', 0, 'name'], this.props.prestation) ||
                  this.props.intl.formatMessage(constants.messages.DETAIL_NO_PAYING_CUSTOMER_MESSAGE)
                }
                secondary={this.props.intl.formatMessage(constants.messages.DETAIL_PAYING_CUSTOMER_LABEL)}
              />

              {
                isStaff &&
                R.path(['paying_customer'], this.props.prestation)
                  ? <React.Fragment>
                    {
                      this.state.openPayingCustomerInformation
                        ? <IconButton onClick={() => this.handleChange('openPayingCustomerInformation', !!!this.state.openPayingCustomerInformation)}>
                          <ExpandLess />
                        </IconButton>
                        : <IconButton onClick={() => this.handleChange('openPayingCustomerInformation', !!!this.state.openPayingCustomerInformation)}>
                          <ExpandMore />
                        </IconButton>
                    }
                  </React.Fragment>
                  : undefined
              }
            </ListItem>

            <Collapse 
              in={
                this.state.openPayingCustomerInformation &&
                isStaff &&
                R.path(['paying_customer'], this.props.prestation)
              }
              unmountOnExit
            >
              <List 
                component="div" 
                disablePadding
                style={this.props.style}
              >
                {
                  payingCustomerPhoneNumbers
                    ? <ListItem
                      style={this.props.itemStyle}
                    >
                      <ListItemText
                        primary={payingCustomerPhoneNumbers}
                        secondary={this.props.intl.formatMessage(constants.messages.PHONE)}
                      />

                    </ListItem>
                    : undefined
                }

                {
                  payingCustomerAddress
                    ? <ListItem
                      style={this.props.itemStyle}
                    >
                      <ListItemText
                        primary={payingCustomerAddress}
                        secondary={this.props.intl.formatMessage(constants.messages.ADDRESS)}
                      />

                    </ListItem>
                    : undefined
                }
              </List>
              <Divider />
            </Collapse>

            <ListItem
              style={this.props.itemStyle}
            >
              <ListItemText
                primary={this.beneficiary()}
                secondary={this.props.intl.formatMessage(constants.messages.DETAIL_BENEFICIARY_LABEL)}
              />
            </ListItem>

            <ListItem
              style={this.props.itemStyle}
            >
              <ListItemText
                primary={
                  R.path(['other_beneficiaries'], this.props.prestation) ||
                  this.props.intl.formatMessage(constants.messages.DETAIL_NO_OTHER_BENEFICIARY_MESSAGE)
                }
                secondary={this.props.intl.formatMessage(constants.messages.DETAIL_OTHER_BENEFICIARIES_LABEL)}
              />
            </ListItem>
          </List>
        </Collapse>
      </List>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

export default injectIntl(
  connect(
    mapStateToProps, 
    undefined
  )(ContributorsPanel)
)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/ContributorsPanel.js